export default __webpack_public_path__ + "static/media/7e40cee29698b46d07f2f16cb561e96c.svg";